import React from 'react';
import { Link } from 'react-router-dom';
import { MapIcon, ZapIcon, SettingsIcon, ArrowRightIcon } from 'lucide-react';
import { useTranslation } from '../i18n';
export function ProductSuite() {
  const {
    t
  } = useTranslation();
  return <section id="products" className="py-32 relative z-20 bg-[#050505]" data-id="element-261">
      <div className="max-w-7xl mx-auto px-6" data-id="element-262">
        <div className="text-center mb-20" data-id="element-263">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-264">
            {t('productSuite.title')}
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto" data-id="element-265">
            {t('productSuite.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-266">
          <div className="group hover-shimmer bg-[#0A0A0A] border border-white/10 rounded-2xl p-8 transition-all duration-300 hover:border-white/20 hover:-translate-y-1 flex flex-col h-full" data-id="element-267">
            <div className="mb-4 relative inline-block" data-id="element-268">
              <div className="absolute inset-0 rounded-full animate-color-cycle blur-md opacity-50 group-hover:opacity-100 transition-opacity duration-500" data-id="element-269"></div>
              <div className="relative bg-[#111] p-4 rounded-2xl border border-white/10 animate-color-cycle" data-id="element-270">
                <MapIcon className="w-8 h-8 text-white" data-id="element-271" />
              </div>
            </div>
            <h3 className="text-2xl font-bold mb-3 text-gradient inline-block" data-id="element-272">
              {t('productSuite.mapName')}
            </h3>
            <p className="text-white/70 mb-8 leading-relaxed flex-1" data-id="element-273">
              {t('productSuite.mapDesc')}
            </p>
            <Link to="/products/map" className="inline-flex items-center text-sm font-semibold text-gradient group-hover:tracking-wide transition-all duration-300 mt-auto" data-id="element-274">
              {t('productSuite.learnMore')}
              <ArrowRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-275" />
            </Link>
          </div>

          <div className="group hover-shimmer bg-[#0A0A0A] border border-white/10 rounded-2xl p-8 transition-all duration-300 hover:border-white/20 hover:-translate-y-1 flex flex-col h-full" data-id="element-276">
            <div className="mb-4 relative inline-block" data-id="element-277">
              <div className="absolute inset-0 rounded-full animate-color-cycle blur-md opacity-50 group-hover:opacity-100 transition-opacity duration-500" data-id="element-278"></div>
              <div className="relative bg-[#111] p-4 rounded-2xl border border-white/10 animate-color-cycle" data-id="element-279">
                <ZapIcon className="w-8 h-8 text-white" data-id="element-280" />
              </div>
            </div>
            <h3 className="text-2xl font-bold mb-3 text-gradient inline-block" data-id="element-281">
              {t('productSuite.sparkName')}
            </h3>
            <p className="text-white/70 mb-8 leading-relaxed flex-1" data-id="element-282">
              {t('productSuite.sparkDesc')}
            </p>
            <Link to="/products/spark" className="inline-flex items-center text-sm font-semibold text-gradient group-hover:tracking-wide transition-all duration-300 mt-auto" data-id="element-283">
              {t('productSuite.learnMore')}
              <ArrowRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-284" />
            </Link>
          </div>

          <div className="group hover-shimmer bg-[#0A0A0A] border border-white/10 rounded-2xl p-8 transition-all duration-300 hover:border-white/20 hover:-translate-y-1 flex flex-col h-full" data-id="element-285">
            <div className="mb-4 relative inline-block" data-id="element-286">
              <div className="absolute inset-0 rounded-full animate-color-cycle blur-md opacity-50 group-hover:opacity-100 transition-opacity duration-500" data-id="element-287"></div>
              <div className="relative bg-[#111] p-4 rounded-2xl border border-white/10 animate-color-cycle" data-id="element-288">
                <SettingsIcon className="w-8 h-8 text-white" data-id="element-289" />
              </div>
            </div>
            <h3 className="text-2xl font-bold mb-3 text-gradient inline-block" data-id="element-290">
              {t('productSuite.opsName')}
            </h3>
            <p className="text-white/70 mb-8 leading-relaxed flex-1" data-id="element-291">
              {t('productSuite.opsDesc')}
            </p>
            <Link to="/products/ops" className="inline-flex items-center text-sm font-semibold text-gradient group-hover:tracking-wide transition-all duration-300 mt-auto" data-id="element-292">
              {t('productSuite.learnMore')}
              <ArrowRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-293" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}